import React, { useState } from 'react';
import styled from 'styled-components';
import { FilterType } from '../FilterData';
import {
  Bottom,
  ButtonBox,
  CancleButton,
  ApplyButton,
} from '../filterOptionModal/OptionModal.styles';
import { S } from '../../SignUP/NewSingUp.style';

interface Props {
  onClose: () => void;
  filters: FilterType;
  setFilters: (filters: FilterType) => void;
}

function AddressOption({ onClose, filters, setFilters }: Props) {
  const [inputValue, setInputValue] = useState(filters.address);

  const handleReset = () => {
    onClose();
  };
  const handleSubmit = () => {
    setFilters({
      ...filters,
      address: inputValue,
    });
    onClose();
  };
  return (
    <Wrapper>
      <OptionBox>
        상세주소
        <InputWrapper>
          <Input
            placeholder="주소 검색"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
        </InputWrapper>
      </OptionBox>
      <Bottom>
        <ButtonBox>
          <CancleButton onClick={handleReset}>취소</CancleButton>
          <ApplyButton onClick={handleSubmit}>저장</ApplyButton>
        </ButtonBox>
      </Bottom>
    </Wrapper>
  );
}

export default AddressOption;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const OptionBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
  gap: 12px;

  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #37383c9c;
`;

const Input = styled.input`
  flex: 1;
  border: none;
  background-color: transparent;

  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;

  &::placeholder {
    color: #616161;
    font-weight: 500;
    font-size: 16px;
    line-height: 145%;
    letter-spacing: -2%;
  }

  -webkit-appearance: none;
  appearance: none;

  &::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
  }

  &:focus {
    outline: none;
    border-color: rgba(23, 30, 38, 0.3);
  }
`;

const InputWrapper = styled.div`
  width: 100%;
  padding: 8px 16px;
  border-radius: 8px;
  background-color: #70737c0d;
  display: flex;
  flex-direction: row;
`;
